module.exports = __webpack_public_path__ + "static/media/7.38a51ec3.png";